import React, { useState } from "react";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/PageRoutes";
import SupportModal from "../components/SupportModal";

const Home = () => {
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);

  return (
    <div>
      <section className="et_landing_main_bg">
        <div className="ct_header_flex">
          <div className="et_logo">
            <img src="img/Logo_blue_new.png" />
          </div>
          <div className="et_login_btns">
            <button
              className="ct_fs_16 ct_fw_400 border-0 bg-transparent me-3"
              onClick={() => {
                navigate(pageRoutes?.login);
              }}
            >
              Login
            </button>
            <a href="javascript:void(0)" onClick={() => {
                navigate(pageRoutes?.signup);
              }} className="ct_get_start_btn">
              Get Started
            </a>
          </div>
        </div>
        <div className="overflow-x-hidden">
          <div className="container mb-3">
            <div className="row mt-5">
              <div className="col-lg-9 mx-auto">
                <div className="ct_fade_up">
                  <h2 className="ct_fs_48 ct_fw_700 text-white text-center mb-3 ">
                    Manage Your Marine Service 
                    <span className="ct_text_theme"> Business Effortlessly</span>
                  </h2>

                  <p className="ct_white_opcity_80 ct_fs_18 ct_fw_400 text-center ">
                    The precision-engineered platform for modern marine service
                    professionals. Streamline bookings, fleet analytics, and
                    yacht maintenance from a single dashboard.
                  </p>
                </div>

                <div className="d-flex justify-content-center  gap-3 ct_flex_wrap_575 mb-0 landing_page_toggle mx-auto ct_mt_70">
                  <button
                    className="et_custom_badge ct_wrap_100_1 active"
                    onClick={() => navigate(pageRoutes.signup)}
                  >
                    Sole Trader
                  </button>
                  <button
                    className="et_custom_badge ct_wrap_100_1"
                    onClick={() => navigate(pageRoutes.signup)}
                  >
                    Small Business
                  </button>
                  <button
                    className="et_custom_badge ct_wrap_100_1"
                    onClick={() => {
                      setIsShow(true);
                    }}
                  >
                    Enterprise
                  </button>
                </div>
              </div>
            </div>
            
          </div>

          <div className="px-5 ct_my_70">
            <div className="row">
              <div className="col-xl-6">
                <div className="ct_bottom_section_main">
                  
                  <ul className="et_login_bottom_bg567">
                    <li>
                      <div className="ct_bottom_sec_icon mb-3">
                        <svg
                          width="19"
                          height="20"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 20V17H11V15H14V12H16V15H19V17H16V20H14ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H11V0H13V2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V10.1C15.6667 10.05 15.3333 10.025 15 10.025C14.6667 10.025 14.3333 10.05 14 10.1V8H2V16H9C9 16.3333 9.025 16.6667 9.075 17C9.125 17.3333 9.21667 17.6667 9.35 18H2ZM2 6H14V4H2V6ZM2 6V4V6Z"
                            fill="#23C0E8"
                          />
                        </svg>
                      </div>

                      <div>
                        <h5 className="mb-2 ct_fs_18 ct_fw_500 text-white">
                          More Bookings, Less Hassle
                        </h5>
                        <p className="mb-0 ct_fs_14 ct_fw_400">
                          Automated intake systems that capture leads 24/7,
                          reducing manual inquiry response times by 80%.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="ct_bottom_sec_icon mb-3">
                        <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.3 14.7L14.7 13.3L11 9.6V5H9V10.4L13.3 14.7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2167 18 14.1042 17.2208 15.6625 15.6625C17.2208 14.1042 18 12.2167 18 10C18 7.78333 17.2208 5.89583 15.6625 4.3375C14.1042 2.77917 12.2167 2 10 2C7.78333 2 5.89583 2.77917 4.3375 4.3375C2.77917 5.89583 2 7.78333 2 10C2 12.2167 2.77917 14.1042 4.3375 15.6625C5.89583 17.2208 7.78333 18 10 18Z"
                            fill="#23C0E8"
                          />
                        </svg>
                      </div>

                      <div>
                        <h5 className="mb-2 ct_fs_18 ct_fw_500 text-white">
                          Automated Scheduling
                        </h5>
                        <p className="mb-0 ct_fs_14 ct_fw_400">
                          Smart dispatching logic that pairs the right
                          technician with the right vessel based on location and
                          skill.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="ct_bottom_sec_icon mb-3">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 20C2.45 20 1.97917 19.8042 1.5875 19.4125C1.19583 19.0208 1 18.55 1 18V6.725C0.7 6.54167 0.458333 6.30417 0.275 6.0125C0.0916667 5.72083 0 5.38333 0 5V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V5C20 5.38333 19.9083 5.72083 19.725 6.0125C19.5417 6.30417 19.3 6.54167 19 6.725V18C19 18.55 18.8042 19.0208 18.4125 19.4125C18.0208 19.8042 17.55 20 17 20H3ZM3 7V18H17V7H3ZM2 5H18V2H2V5ZM7 12H13V10H7V12Z"
                            fill="#23C0E8"
                          />
                        </svg>
                      </div>

                      <div>
                        <h5 className="mb-2 ct_fs_18 ct_fw_500 text-white">
                          Parts & Inventory
                        </h5>
                        <p className="mb-0 ct_fs_14 ct_fw_400">
                          Real-time tracking of marine components and automated
                          reordering from your preferred maritime suppliers.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="ct_bottom_sec_icon mb-3">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16ZM2 2V16V2Z"
                            fill="#23C0E8"
                          />
                        </svg>
                      </div>

                      <div>
                        <h5 className="mb-2 ct_fs_18 ct_fw_500 text-white">
                          Fleet Reporting
                        </h5>
                        <p className="mb-0 ct_fs_14 ct_fw_400">
                          Comprehensive performance metrics for managed vessels,
                          ensuring precision service and long-term yacht value.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="ct_bottom_section_main">
                  <img src="img/mockup-right.png" className="mockup_img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     
      {isShow && <SupportModal onClick={() => setIsShow(false)} />}
    </div>
  );
};

export default Home;
